<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{$t('message.品牌详情类型管理')}}</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">  
          <el-link
            :underline="false"
          >
          <el-button size="medium" round @click="createTarget">
            <i class="iconfont" >&#xe727;</i>
            {{$t('message.新建')}}
          </el-button>
          </el-link>
          <el-link
            :underline="false"
          >
          <el-button size="medium" round @click.native="refresh">
            <i class="iconfont" >&#xe667;</i>
            {{$t('message.刷新')}}
          </el-button>
          </el-link>
          <!-- <el-link
            :underline="false"
          >
            <el-button size="medium" round :loading="false" @click.native="exportDialogVisible = true">
              <i class="iconfont" >&#xe769;</i>
              导出
            </el-button>
          </el-link> -->
        </div>
      </div>
      <div class="grid-content content-margin">
        <el-divider></el-divider>
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.筛选')}}</span>
            </td>
            <td >
              <el-input
              clearable
              prefix-icon="el-icon-search"
              v-model="search"
              size="small"
              :placeholder="$t('message.输入关键字')"/>
            </td>
          </tr>
        </table>
      </div>
      <div class="grid-content content-margin">
        <el-table
          ref="table"
          :data="filterData"
          stripe
          border
          :height="tableHeight"
          style="width: 100%;">
          <el-table-column
            fixed
            label="No."
            type="index"
            width="55">
          </el-table-column>
          <el-table-column fixed width="160" :label="$t('message.操作')" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" round type="normal" icon="el-icon-zoom-in" @click="editTarget(scope.row, false)"></el-button>
                <el-button size="mini" round type="normal" icon="el-icon-edit" @click="editTarget(scope.row, true)"></el-button>
                <el-button size="mini" round type="normal" icon="el-icon-delete" @click="targetRow = scope.row; deleteDialogVisible = true;"></el-button>
              </el-button-group>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="detailtypeid"
            :label="$t('message.详情类型ID')"
            width="160">
          </el-table-column>
          <el-table-column
            sortable
            prop="name"
            :label="$t('message.详情类型名称')"
            >
          </el-table-column>
          <el-table-column
            sortable
            prop="sort"
            :label="$t('message.排序')"
            width="160"
            >
          </el-table-column>
          <el-table-column
            sortable
            prop="editdate"
            :label="$t('message.更新日期')"
            min-width="160"
            >
          </el-table-column>
          <el-table-column
            sortable
            prop="editid"
            :label="$t('message.更新人')"
            min-width="160"
            >
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        :title="$t('message.删除确认')"
        :visible.sync="deleteDialogVisible"
        width="300px"
        :modal="false"
        center
        :before-close="handleClose"
      >
          <i class="iconfont" >&#xe766;</i>
          <span>{{$t('message.请确认是否删除该内容')}}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deleteDialogVisible = false">{{$t('message.取消')}}</el-button>
            <el-button type="primary" @click.native="deleteTarget">{{$t('message.删除')}}</el-button>
          </span>
      </el-dialog>

      <el-dialog
        :title="$t('message.导出')"
        :visible.sync="exportDialogVisible"
        width="300px"
        :modal="false"
        center
      >
        <span style="display: inline-block;">{{$t('message.请确认是否导出')}}</span>
        <!-- show-checkbox
          :check-on-click-node="true"
          :check-strictly="true" -->
        <!-- @node-click="handleNodeClick" -->
        <span slot="footer" class="dialog-footer">
           <el-link
            :underline="false"
          >
            <el-button @click="exportDialogVisible = false">{{$t('message.取消')}}</el-button>
          </el-link>
          <el-link
            :href="'/manage/wechat/downloadtagusers'"
            :underline="false"
          >
            <el-button type="primary" @click.native="exportTag">{{$t('message.导出')}}</el-button>
          </el-link>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "BrandTypeList",
  data() {
    return {
      tableHeight: 500,
      filterText: "",
      tempName: "",
      deleteDialogVisible: false,
      exportDialogVisible: false,
      targetRow: null,
      tableData: [],
      search: "",
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 150;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 150;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    refresh() {
      rejecthttp(true,'get',"/manage/brand/getbrandtypelist",{
            appid: 188,
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
            console.log(doc.data);
            this.tableData = doc.data.data;
            this.tableData.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
            });
            }
            });
      // this.$http
      //   .get("/manage/brand/getbrandtypelist", {
      //     params: {
      //       appid: 188,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       console.log(doc.data);
      //       this.tableData = doc.data.data;
      //       this.tableData.forEach((any) => {
      //         any.editdate = commonUtil.formatDate(any.editdate);
      //       });
      //     }
      //   });
    },
    exportAll() {
      rejecthttp(true,'get',"/manage/wechat/exporttags",{
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
            this.tableData = doc.data.data;
            }
            });
      // this.$http.get("/manage/wechat/exporttags", {}).then((doc) => {
      //   // console.log(doc.data)
      //   if (doc.data.Code != "MSGKEY_OK") {
      //     this.$message({
      //       type: "error",
      //       message: doc.data.Message,
      //     });
      //   } else {
      //     this.tableData = doc.data.data;
      //   }
      // });
    },
    createTarget() {
      this.$router.push({name: 'brandTypeDetail', query: { appid: 188}})
    },
    editTarget(data, edit) {
      this.$router.push({name: 'brandTypeDetail', query: {id: data.detailtypeid, appid: 188, isEditMode: edit}})
    },
    deleteTarget() {
      console.log(this.targetRow);
      rejecthttp(true,'post',"/manage/brand/deletebrandtypeinfo",{
            first: 188,
            second: this.targetRow.detailtypeid,
          },this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
            // this.tableData = doc.data.data;
            }
            this.deleteDialogVisible = false;
            this.refresh();
            });
      // this.$http
      //     .post("/manage/brand/deletebrandtypeinfo", {
      //       first: 188,
      //       second: this.targetRow.detailtypeid,
      //     })
      //     .then((doc) => {
      //       // console.log(doc.data)
      //       if (doc.data.Code != "MSGKEY_OK") {
      //         this.$message({
      //           type: "error",
      //           message: doc.data.Message,
      //         });
      //       } else {
      //         this.$message({
      //           type: "success",
      //           message: doc.data.Message,
      //         });
      //       }
      //       this.deleteDialogVisible = false;
      //       this.refresh();
      //     });
    },
    exportTag() {
      this.exportDialogVisible = false;
      // 提交
      rejecthttp(true,'get',"/manage/wechat/exporttagusers",{
             tagid: this.targetRow.id 
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
            this.percentageUserExport = 0;
            this.endExportUser = false;
            this.userExportDialogVisible = true;
            // 开启定时器
            window.clearInterval(this.timeHandleExportUser);
            this.timeHandleExportUser = setInterval(() => {
              this.onProgressCommit();
            }, 400);
            }
            });
      // this.$http
      //   .get("/manage/wechat/exporttagusers", {
      //     params: { tagid: this.targetRow.id },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       // 打开进度条面板
      //       this.percentageUserExport = 0;
      //       this.endExportUser = false;
      //       this.userExportDialogVisible = true;
      //       // 开启定时器
      //       window.clearInterval(this.timeHandleExportUser);
      //       this.timeHandleExportUser = setInterval(() => {
      //         this.onProgressCommit();
      //       }, 400);
      //     }
      //   });
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.refresh();
  },
  computed: {
    filterData() {
      if (this.tableData)
        return this.tableData.filter(
          (data) =>
            !this.search ||
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            data.detailtypeid.toString().toLowerCase().includes(this.search.toLowerCase())
        );
      else return [];
    },
  },
};
</script>

<style scoped>
.el-table /deep/ td {
    user-select: text!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/brands/BrandTypeList.vue